<template>
	<div class="col-xs-12">
		<div style="border: 10px solid red; padding: 10px; min-height: 1000px">
			<div class="row">
				<div class="col-xs-3 text-center" style="padding: 0px">
					<img :src="_img2" style="width: 104px; margin-top: 8px" />
				</div>
				<div
					class="col-xs-6 text-center"
					style="padding: 0px; vertical-align: middle"
				>
					<h5>{{ _titulo }}</h5>
					<h2 style="color: red !important; margin: 0px">- RELPREV -</h2>
					<h4 style="margin: 0px; margin-top: 10px; margin-bottom: 10px">
						{{ _labelRelatorioPrevencao.titulo.toUpperCase() }}
					</h4>
				</div>
				<div class="col-xs-3 text-center" style="padding: 0px">
					<img :src="_img1" style="width: 104px; margin-top: 8px" />
				</div>
			</div>

			<div class="row" style="margin-top: 5px;">
				<div class="col-md-12 text-center">
					<div style="border: 2px solid #333">
						<p style="margin-top: 16px; margin-bottom: 16px">
							<strong>{{
								_traducao('menuAGprevencao', 'menuAGrelatoOcorrencia')
							}}</strong>
						</p>
					</div>
				</div>
			</div>

			<div class="row" style="margin-top: 20px">
				<div class="col-md-12">
					<div style="border: 2px solid #333; padding: 10px">
						<div class="row">
							<div class="col-xs-8">
								<label
									>{{
										_traducao('menuAGpermutas', 'menuAGcidade').toUpperCase()
									}}:</label
								>
								{{ relatorio.cidade }}
							</div>
							<div class="col-xs-4">
								<label
									>{{
										_traducao('menuAGpermutas', 'menuAGestado').toUpperCase()
									}}:</label
								>
								{{ relatorio.estado }}
							</div>
						</div>
						<div class="row">
							<div class="col-md-8">
								<label
									>{{
										_traducao('menuAGpermutas', 'menuAGlocal').toUpperCase()
									}}:</label
								>
								{{ relatorio.local }}
							</div>
							<div class="col-md-4">
								<label
									>{{ _traducao('global', 'codigo').toUpperCase() }}:</label
								>
								{{ relatorio.codigo }}
							</div>
						</div>
						<div class="row">
							<div class="col-md-6">
								<label
									>{{ _traducao('global', 'evento').toUpperCase() }}:</label
								>
								{{ relatorio.descricao_evento }}
							</div>
						</div>
						<div class="row">
							<div class="col-md-6">
								<label
									>{{
										_traducao('menuAGpermutas', 'menuAGdata').toUpperCase()
									}}</label
								>
								{{ relatorio.data }}
							</div>
						</div>
						<div class="row">
							<div class="col-md-6">
								<label
									>{{
										_traducao(
											'menuAGpermutas',
											'menuAGenvolvidos'
										).toUpperCase()
									}}:</label
								>
								{{ relatorio.envolvidos }}
							</div>
						</div>
						<div class="row">
							<div class="col-md-6">
								<label
									>{{
										_traducao('menuAGpermutas', 'menuAGaeronave').toUpperCase()
									}}:</label
								>
								{{ relatorio.codinome }} -
								{{ relatorio.prefixo }}
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="row" style="margin-top: 20px">
				<div class="col-md-12" style="overflow-wrap: break-word">
					<p>
						<strong
							>{{
								_traducao('menuAGpermutas', 'menuAGsituacao').toUpperCase()
							}}:</strong
						>
						{{ relatorio.descricao }}
					</p>
				</div>
			</div>
			<div class="row" style="margin-top: 20px">
				<div v-if="relatorio.parecer.length > 0">
					<div
						class="col-md-12"
						style="overflow-wrap: break-word"
						v-for="(parecer, index) in relatorio.parecer"
					>
						<p v-if="parecer.informacao_publica == '1' || _getPrivilegio(303)">
							<strong
								>{{
									_traducao('menuAGpermutas', 'menuAGparecer').toUpperCase()
								}}
								{{ index + 1 }}:</strong
							>
							{{ parecer.parecer }}
						</p>
					</div>
				</div>
			</div>

			<div
				class="row"
				v-show="relatorio.conclusao != null"
				style="margin-top: 10px"
			>
				<div class="col-md-12" style="overflow-wrap: break-word">
					<p>
						<strong
							>{{
								_traducao('menuAGpermutas', 'menuAGconclusao').toUpperCase()
							}}:</strong
						>
						{{ relatorio.conclusao }}
					</p>
				</div>
			</div>

			<div class="row" style="margin-top: 20px">
				<div class="col-md-12">
					<div style="border: 2px solid #333; padding: 10px">
						<div class="row">
							<div class="col-md-12">
								<label
									>{{
										_traducao('menuAGpermutas', 'menuAGnome').toUpperCase()
									}}:</label
								>
								{{ relatorio.relator }}
							</div>
						</div>
						<div class="row">
							<div class="col-xs-8">
								<label
									>{{
										_traducao('menuAGpermutas', 'menuAGemail').toUpperCase()
									}}:</label
								>
								{{ relatorio.email }}
							</div>
							<div class="col-xs-4">
								<label
									>{{
										_traducao('menuAGpermutas', 'menuAGtel').toUpperCase()
									}}:</label
								>
								{{ formatPhoneNumber(relatorio.telefone) }}
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="row" style="margin-top: 20px">
				<div class="col-md-12">
					<div 
						v-if="relatorio.status?.toUpperCase() == 'CANCELADO' || 
						relatorio.status?.toUpperCase() == 'CANCELADO TRATADO'"
					>
						<div class="row">
							<div class="col-md-12">
							  <strong>Cancelado por:</strong>
								{{ relatorio.usuario_cancelamento }}  - {{ _SQLDateToDateTime(relatorio.data_cancelamento, _getDataFormat + ' HH:MM') }}
							</div>
						</div>
						<div class="row">
							<div class="col-xs-8">
								<strong>Motivo:</strong>
								{{ relatorio.cancelamento }}
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="row no-print" style="margin-top: 20px">
				<div class="col-md-12">
					<div 
						style="border: 2px solid #333; padding: 10px" 
						v-if="relatorio.anexos && relatorio.anexos.length > 0"
					>
						<div class="row">
							<div class="col-xs-12 col-sm-12 col-md-6 col-lg-5">
								<label style="font-size: 14pt !important"
									>{{ _traducao('global', 'lista').capitalizeFirst() }}
									{{ _traducao('global', 'de').toLowerCase() }}
									{{ _traducao('global', 'anexos') }}
								</label>
								<ul style="list-style-type: none; padding-left: 2%">
									<li v-for="anexo of relatorio.anexos" :key="anexo.caminho">
										<a @click="abreLink(anexo.link)"> {{ anexo.nome }} </a>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import formatPhoneNumber from '@/helpers/formatPhoneNumber.js'

export default {
	name: 'RelatorioPrevencaoPrintLayout1',

	props: {
		relatorio: {
			type: Object,
			required: true
		}
	},

	methods: {
		formatPhoneNumber,

		abreLink(url) {
			let a = document.createElement('a')
			a.href = url
			a.target = '_blank'
			document.body.appendChild(a)
			a.click()
		}
	}
}
</script>